import React, { Component } from "react";
import {Container, Row, Col,Image,Accordion,Button,OverlayTrigger,Tooltip,Form,Alert,Card  } from 'react-bootstrap';
import { withRouter,Link } from "react-router-dom";
import loader from '../../images/loader.gif';
import "../EventsAndActivities/EventsAndActivities.css";
import axios from 'axios';
import arrowLeft from '../../images/arrow-left.png';
import SelectBox from '../SelectDropDown/SelectDropDown';
import { components } from 'react-select';
import CapturePhotoForD2D from "./CapturePhotoForD2D";

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
  };

class HouseWiseVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
     webcamRef : React.createRef(),
     campaignId:props?.location?.params?.campaignId == undefined ? "" : props?.location?.params?.campaignId,
     campaignName:props?.location?.params?.campaignName == undefined ? "" : props?.location?.params?.campaignName,
     houseNumberId:props?.location?.params?.houseNumberId == undefined ? "" : props?.location?.params?.houseNumberId,
     houseNumber:props?.location?.params?.houseNumber == undefined ? "" : props?.location?.params?.houseNumber,
     userIdSet:props?.location?.params?.userIdSet == undefined ? "" : props?.location?.params?.userIdSet,

     boothParam:props?.location?.params?.boothParam || {},
     constituencyParam:props?.location?.params?.constituencyParam || {},
     
    verificationId:"",
    latitude: "",
    longitude: "",
    mobileLocationError: "Checking Mobile Location Is Enabled.....",

    camaraRadioButtonNew:true,
    uploadImageRadioButtonNew:false,
    selectedTypePhotoNew:"camara",
    showActivityImgCaptureNew:false,
    manualUploadImageNew:"",
    photoCaptureForActivityArrNew:[],
    validateActivityImageUpload:"",
    validatePhotoCapture:"",
    manualuploadPhotoForD2D:false,
    imageVerifyFormData:"",
    verifyLoadingSymbol:"hide",
    verificationPhotoResponse:"",
    photoSuccessBlock:"",
    verifyPhotoDisabled:false,
    photoCaptureBlock:"show",
    campaignQuestionsArr:[],
    currentStep: 0,
    answers:{},
    error:'',
    isQuestionsLoaded: false,  // ✅ Add this flag
    savingAswersLoading:"hide",
    savingAnswersResponse:""
     
    };
    this.uploadMultipleFilesForPhotosNew = this.uploadMultipleFilesForPhotosNew.bind(this)
    
  }

  componentDidMount() {
    if(this.state.campaignId == ""){
        this.props.history.push({pathname:"/d2dCampagin",params: { navbarDisplay:"show"}});
    }else{
         this.checkLocationAccess();
        
         
    }
  }


  checkLocationAccess = () => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // ✅ Location available
          this.setState({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            mobileLocationError: ""
          });

           this.getTokenForD2DCampaignForHouse(position.coords.latitude,position.coords.longitude);
        },
        (error) => {
          // ❌ Error handling
          console.error("errorML",error);
          if (error.code === error.PERMISSION_DENIED) {
            alert('⚠️ Please enable location services on your mobile device.');
          } else if (error.code === error.POSITION_UNAVAILABLE) {
            alert('⚠️ Location information is unavailable.');
          } else if (error.code === error.TIMEOUT) {
            alert('⚠️ The request to get your location timed out.');
          } else {
            alert('⚠️ An unknown error occurred while fetching location.');
          }
           console.error("errorML",error.message);
           this.setState({ mobileLocationError: "Please Enabled Mobile Location Then Re-start The Telegram Bot" });
        },
        {
          timeout: 10000,         // 10 sec max wait
          enableHighAccuracy: true
        }
      );
    } else {
      alert('Geolocation is not supported by your browser.');
    }
  };


getTokenForD2DCampaignForHouse = async(lat,long) => {
  try {
    const response = await axios.get(
      'https://api.mytdpapp.com/megatron/mytdp/iam/api/v1/users/admin',
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    const token = response.data.token; // or adjust key as per actual response
    this.setState({tokenSet:token})
    console.log('✅ Token:', token);

    this.getHouseVerificationCall(token,lat,long);
    this.getQuestionnairesData(token);
   
  } catch (error) {
     this.setState({tokenSet:""})
    console.error('❌ Failed to get token:', error.response?.data || error.message);
  }
}

 getHouseVerificationCall = async (tokenStr,lat,long) => {
  try {
    const response = await axios.put(
      'https://api.mytdpapp.com/megatron/pp/api/v1/campaigns/campaign-address/verify',
      {
        "latitude": lat == undefined || lat == null || lat == "" ? "17.444167811552454" : lat,
        "longitude": long == undefined || long == null || long == "" ? "78.383642473215" : long,
        "campaignId": this.state.campaignId,
        "addressId": this.state.houseNumberId,
        "allowMoreAddresses": false
      },
      {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
          'Content-Type': 'application/json' // (optional but recommended)
        }
      }
    );

    if(response.data !=null){
       if(response.data?.id !=""){
        this.setState({verificationId:response.data?.id});
        
       }else{
         this.setState({verificationId:""})
       }
    }else{
        this.setState({verificationId:""})
    }

  } catch (error) {
    this.setState({verificationId:""})
    console.error("Error fetching constituency booths:", error.response?.data || error.message);
  }
};

  
selectCaptureTypeNew = (type) => {
    this.setState({photoCaptureForActivityArrNew:[],manualUploadImageNew:"",validateActivityImageUpload:"",imageVerifyFormData:""});
   
        
    if(type == "upload"){
      this.setState({ camaraRadioButtonNew:false,uploadImageRadioButtonNew:true});
      this.setState({showActivityImgCaptureNew:false,manualuploadPhotoForD2D:true});
    }else{
      this.setState({ camaraRadioButtonNew:true,uploadImageRadioButtonNew:false});
      this.setState({showActivityImgCaptureNew:true,manualuploadPhotoForD2D:false});
    }
    

    this.setState({selectedTypePhotoNew:type});
  }
  
  captureForActivityImageUploadNew = async () => {
      this.setState({photoCaptureForActivityArrNew:[]}); 
      this.setState({showActivityImgCaptureNew:true,manualuploadPhotoForD2D:false});
  
  
      const getUID = (length=8) => {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
      }
  
      var obj={
          fileId : getUID(),
          data : this.state.webcamRef.current.getScreenshot(),
        }
  
        this.setState({validateActivityImageUpload:"Photo is Validating...Please wait"});
  
       setTimeout(() => {
            this.setState({photoCaptureForActivityArrNew:[...this.state.photoCaptureForActivityArrNew, obj]}); 
            this.setState({validateActivityImageUpload:""});
        }, 500);

        // Convert base64 to Blob
        const blob = await fetch(obj.data).then(res => res.blob());

        const formData = new FormData();
        formData.append("files", blob, obj.fileId.jpeg);
        this.setState({showActivityImgCaptureNew:false,manualuploadPhotoForD2D:false});

        console.log("photoCaptureForActivityArrNew",formData);
        this.setState({imageVerifyFormData:formData})
        


        console.log("photoCaptureForActivityArrNew",this.state.showActivityImgCaptureNew);

  };

   getExtensionFromType = (mimeType) => {
    const map = {
        'image/jpeg': 'jpg',
        'image/png': 'png',
        'image/webp': 'webp',
        'image/gif': 'gif'
    };
    return map[mimeType] || 'jpg'; // default to jpg
    };

  toDataURL = url => fetch(url)
      .then(response => response.blob())
      .then(blob => new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(blob)
    }))

    uploadMultipleFilesForPhotosNew = async(e) => {
        this.setState({showActivityImgCaptureNew:false,manualuploadPhotoForD2D:true});
        this.setState({photoCaptureForActivityArrNew:[]});
        this.setState({manualUploadImageNew:""});
        const getUID = (length=8) => {
            var result           = '';
            var characters       = '0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
          }
    
        let fileObj=[];
          fileObj.push(e.target.files);
              for (let i = 0; i < fileObj[0].length; i++) {
    
                if(fileObj[0][i].type == "image/jpeg" || fileObj[0][i].type == "image/png" || fileObj[0][i].type == "image/jpg"){
                        this.toDataURL(URL.createObjectURL(fileObj[0][i]))
                        .then(async (dataUrl)  => {
                            this.setState({manualUploadImageNew:"Photo is Validating...Please wait"});
                            
                             var obj ={
                                fileId:getUID(),
                                fileType:fileObj[0][i].type,
                                data:dataUrl,
                            }
                            this.setState({photoCaptureForActivityArrNew:[...this.state.photoCaptureForActivityArrNew, obj]});
                            this.setState({manualUploadImageNew:"Photo Upload Successfully..."});

                             // Convert base64 to Blob
                            const blob = await fetch(obj.data).then(res => res.blob());

                            const fileType = obj.fileType; // e.g., "image/jpeg"
                            const fileExt = this.getExtensionFromType(fileType);
                             const formData = new FormData();
                            formData.append("files", blob, `image.${fileExt}`);

                            this.setState({showActivityImgCaptureNew:false,manualuploadPhotoForD2D:false});
                            this.setState({imageVerifyFormData:formData})
                           

                            console.log("photoCaptureForActivityArrNewxxx",formData,fileType);
                            
                        });
                }
                  
              }
    
              
      }

  retakeCapturePhoto = () => {
    if(this.state.selectedTypePhotoNew == "camara"){
        this.setState({showActivityImgCaptureNew:true,manualuploadPhotoForD2D:false});
    }else{
        this.setState({showActivityImgCaptureNew:false,manualuploadPhotoForD2D:true});
    }
    
    this.setState({photoCaptureForActivityArrNew:[],imageVerifyFormData:"",verifyPhotoDisabled:false,verificationPhotoResponse:"",photoSuccessBlock:""});
  }

  showCaptureClickPhoto = () => {
    this.setState({photoCaptureBlock:"hide",showActivityImgCaptureNew:true});
  }

  verifyPhotoForD2D = () => {
    this.getTokenForD2DCampaignPhoto();
  }
  
  getTokenForD2DCampaignPhoto = async() => {
    try {
      const response = await axios.get(
        'https://api.mytdpapp.com/megatron/mytdp/iam/api/v1/users/admin',
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
  
      const token = response.data.token; // or adjust key as per actual response
      this.setState({tokenSet:token})
      console.log('✅ Token:', token);
  
      this.photoVerifiedCallD2D(token);
     
    } catch (error) {
       this.setState({tokenSet:""})
      console.error('❌ Failed to get token:', error.response?.data || error.message);
    }
  }

  
  photoVerifiedCallD2D = async (tokenStr) => {
    this.setState({verifyLoadingSymbol:"show",verificationPhotoResponse:"",photoSuccessBlock:""})
    try {
      const response = await axios.post(
        `https://api.mytdpapp.com/megatron/pp/api/v1/files/upload/${this.state.verificationId}`,
        this.state.imageVerifyFormData,
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

      console.log("response.dataImage",response.data)
      this.setState({verifyLoadingSymbol:"hide"})
      if(response.data !=null && response.data?.data.length>0){
        this.setState({verificationPhotoResponse:"Photo Verification SuccessFully",verifyPhotoDisabled:true,photoSuccessBlock:"hide"})
      }else{
         this.setState({verificationPhotoResponse:response.data?.message,photoSuccessBlock:""})
      }
  
    } catch (error) {
        this.setState({verifyLoadingSymbol:"hide"})
         this.setState({verificationPhotoResponse:"SomeThing Went Wrong,Please Try Again...",photoSuccessBlock:""})
      console.error("Error fetching constituency booths:", error.response?.data || error.message);
    }
  };

 getQuestionnairesData =  async (tokenStr) => {
  try {
    const response = await axios.get(
      `https://api.mytdpapp.com/megatron/pp/api/v1/campaigns/${this.state.campaignId}/questionnaires`,
      {
        headers: {
          Authorization: `Bearer ${tokenStr}`
        }
      }
    );

    const questions = response.data?.response?.questionnaires?.[0]?.questions || [];

    this.setState({
      campaignQuestionsArr: questions,
      isQuestionsLoaded: true  // ✅ set loaded
    });

    console.log("✅ Loaded questions:", questions);
  } catch (error) {
    console.error("❌ Error fetching campaigns:", error.response?.data || error.message);
    this.setState({ campaignQuestionsArr: [], isQuestionsLoaded: true });  // mark as loaded even on failure
  }
};

 renderQuestion = (question) => {
  const { answers } = this.state;

  switch (question.type) {
    case 'radio':
      return question.options.map((opt) => {
        const inputId = `${question.id}_${opt.id}`;
        return (
          <Form.Check
            inline
            key={opt.id}
            type="radio"
            id={inputId}
            name={question.id}
            className="mb-2 f-14"
          >
            <Form.Check.Input
              type="radio"
              name={question.id}
              value={opt.id}
              checked={answers[question.id] === opt.id}
              onChange={() => this.handleChange(question.id, opt.id, 'radio')}
            />
            <Form.Check.Label htmlFor={inputId}>
              {opt.optionText}
            </Form.Check.Label>
          </Form.Check>
        );
      });

    case 'checkbox':
      return question.options.map((opt) => {
        const inputId = `${question.id}_${opt.id}`;
        return (
          <Form.Check
            inline
            key={opt.id}
            type="checkbox"
            id={inputId}
            className="mb-2 f-14"
          >
            <Form.Check.Input
              type="checkbox"
              value={opt.id}
              checked={(answers[question.id] || []).includes(opt.id)}
              onChange={() =>
                this.handleChange(question.id, opt.id, 'checkbox')
              }
            />
            <Form.Check.Label htmlFor={inputId}>
              {opt.optionText}
            </Form.Check.Label>
          </Form.Check>
        );
      });

    case 'text':
      return (
        <Form.Control
          type="text"
          placeholder="Enter your answer"
          value={answers[question.id] || ''}
          onChange={(e) =>
            this.handleChange(question.id, e.target.value, 'text')
          }
        />
      );

    default:
      return null;
  }
};


handlePrev = () => {
  this.setState((prevState) => ({
    currentStep: prevState.currentStep - 1,
    error: ''
  }));
};

handleNext = () => {
  const validationError = this.validateAnswer();
  if (validationError) {
    this.setState({ error: validationError });
    return;
  }

  this.setState((prevState) => ({
    currentStep: prevState.currentStep + 1,
    error: ''
  }));
};

validateAnswer = () => {
  const { campaignQuestionsArr, currentStep, answers } = this.state;
  const currentQ = campaignQuestionsArr[currentStep];
  const ans = answers[currentQ.id];

  if (currentQ.required) {
    if (currentQ.type === 'radio' && !ans) {
      return 'Please select one option.';
    }
    /*if (currentQ.type === 'checkbox') {
      const requiredCount = currentQ.options.length;
      if (!ans || ans.length < requiredCount) {
        return 'Please select all options.';
      }
    }*/

    if (currentQ.type === 'checkbox') {
      if (!ans || ans.length === 0) {
        return 'Please select at least one option.';
      }
    }

    if (currentQ.type === 'text' && (!ans || ans.trim() === '')) {
      return 'Please enter a valid answer.';
    }
  }

  return '';
};

handleChange = (qId, value, type) => {
  const { answers } = this.state;

  if (type === 'checkbox') {
    const current = answers[qId] || [];
    const updated = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];
    this.setState({ answers: { ...answers, [qId]: updated } });
  } else {
    this.setState({ answers: { ...answers, [qId]: value } });
  }
};

buildFinalPayload = () => {
  const { campaignQuestionsArr, answers, houseNumberId } = this.state;

  //const userId = this.state.tokenSet; // or fetch from user info if different

  const requests = campaignQuestionsArr.map((question) => {
    const answer = answers[question.id];

    let questionOptionIds = [];
    let textAnswer = "";

    if (question.type === "radio") {
      questionOptionIds = answer ? [answer] : [];
    } else if (question.type === "checkbox") {
      questionOptionIds = answer || [];
    } else if (question.type === "text") {
      textAnswer = answer || "";
    }

    return {
      campaignAddressId: this.state.verificationId,
      userId: this.state.userIdSet,
      questionId: question.id,
      questionOptionIds: questionOptionIds,
      textAnswer: textAnswer
    };
  });

  return { requests };
};


handleSubmit =  () => {
    
     this.getTokenForD2DCampaignSaving();
  };

  
getTokenForD2DCampaignSaving = async() => {
    this.setState({savingAswersLoading:"show"})
  try {
    const response = await axios.get(
      'https://api.mytdpapp.com/megatron/mytdp/iam/api/v1/users/admin',
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    const token = response.data.token; // or adjust key as per actual response
    this.setState({tokenSet:token})
    console.log('✅ Token:', token);

    this.savingQuestions(token);
   
  } catch (error) {
     this.setState({tokenSet:""})
    console.error('❌ Failed to get token:', error.response?.data || error.message);
  }
}

savingQuestions =  (tokenStr) => {
     const finalPayload = this.buildFinalPayload();
    console.log("Submitting this payload:", finalPayload);

     setTimeout(async () => {
            try {
                const response = await axios.post(
                `https://api.mytdpapp.com/megatron/pp/api/v1/campaigns/questions/answers`,finalPayload,
                {
                    headers: {
                        Authorization: `Bearer ${tokenStr}`
                    }
                }
                );

                this.setState({savingAswersLoading:"hide"});

                console.log("ssssssssssss",response.data?.data)

                if(response !=null && response.data?.data.length>0){
                   this.setState({savingAnswersResponse:"Questionnaires Submitted SuccessFully"});
                   
                   setTimeout(() => {
                       this.props.history.push({pathname:"/campaign_wise_houses",params: {navbarDisplay:"hide",campaignId:this.state.campaignId,campaignName:this.state.campaignName,boothParam:this.state.boothParam,constituencyParam:this.state.constituencyParam,userIdSet:this.state.userIdSet}});
                    }, 2000);
                   
                }else{
                    this.setState({savingAnswersResponse:"SomeThing Went Wrong,Please Try Again"}) 
                }
                
                console.log("✅ Loaded questions:", response);
            } catch (error) {
                this.setState({savingAswersLoading:"hide"});
                this.setState({savingAnswersResponse:"SomeThing Went Wrong,Please Try Again"}) 
                console.error("❌ Error fetching campaigns:", error.response?.data || error.message);
            }
    }, 1000);
    
}

  render() {
   
    return (
      <section className="background_yellow_d2d">
        <div className='bg_yellow_event'>
            <div className='flex_event_name_top'>
                    <div>
                         <Link to={{pathname: "/campaign_wise_houses",params: {navbarDisplay:"hide",campaignId:this.state.campaignId,campaignName:this.state.campaignName,boothParam:this.state.boothParam,constituencyParam:this.state.constituencyParam}}}> <Image src={arrowLeft} alt="Arrow" ></Image></Link>
                                                    
                    </div>  
                    <div>
                        <h6 className='color_white fw-bold mt-3'>
                            {this.state.campaignName} :
                            {
                                this.state.houseNumber != "" ?
                                (<><br/><span className="fw-bold color_black" style={{marginLeft:"0px"}}>House No -  {this.state.houseNumber} D2D Visit</span></>)
                                :
                                ("")
                            }
                        </h6>
                    </div> 
            </div>
        </div>
      
      <Container>
          <Row>
             <Col>
                {
                    this.state.mobileLocationError != "" ?
                    ( <h6 className="color_red mt-3 text-center">{this.state.mobileLocationError}</h6>)
                    :
                    ("")
                }
                {
                    this.state.photoSuccessBlock == "" ?
                    (
                         <CapturePhotoForD2D
                            stateData={this.state}
                            selectCaptureTypeNew={this.selectCaptureTypeNew}
                            captureForActivityImageUploadNew={this.captureForActivityImageUploadNew}
                            retakeCapturePhoto={this.retakeCapturePhoto}
                            uploadMultipleFilesForPhotosNew={this.uploadMultipleFilesForPhotosNew}
                            verifyPhotoForD2D={this.verifyPhotoForD2D}
                            showCaptureClickPhoto={this.showCaptureClickPhoto}
                        />
                    )
                    :
                    ("")
                }
               

             </Col>
          </Row>

            {this.state.verificationPhotoResponse === "Photo Verification SuccessFully" &&
                    this.state.isQuestionsLoaded &&
                    this.state.campaignQuestionsArr.length > 0 &&
                    this.state.currentStep < this.state.campaignQuestionsArr.length && (
                    <Row>
                        <Col>
                        <Card className="shadow-sm rounded-3 mt-3" style={{padding:"10px 15px",border:"1px solid #000"}}>
                            <h6 className="text-muted fw-bold mt-3">Questionnaires : </h6>

                            <h5 className="text-center mb-3">
                            {this.state.currentStep + 1}/{this.state.campaignQuestionsArr.length}
                            </h5>
                            <Form>
                            <p className="text-center text-muted f-12">
                            {this.state.campaignQuestionsArr[this.state.currentStep].type == 'radio' ? 'Select one option' :
                            this.state.campaignQuestionsArr[this.state.currentStep].type == 'checkbox' ? 'Select one or more options' :
                            'Enter your response'}
                        </p>
                        
                            <h5 className="text-center fw-bold f-14">
                                {this.state.campaignQuestionsArr[this.state.currentStep].questionText}
                            </h5>
                            {this.state.campaignQuestionsArr[this.state.currentStep].required && (
                                <p className="text-danger text-center fw-semibold f-12">* Required</p>
                            )}
                            <div className="mt-3">
                                {this.renderQuestion(this.state.campaignQuestionsArr[this.state.currentStep])}
                            </div>
                            {this.state.error && (
                                <Alert variant="danger" className="mt-3">
                                {this.state.error}
                                </Alert>
                            )}
                            <div className="d-flex justify-content-between mt-4">
                                <Button
                                variant="secondary"
                                onClick={this.handlePrev}
                                disabled={this.state.currentStep === 0}
                                >
                                Prev
                                </Button>
                                {this.state.currentStep < this.state.campaignQuestionsArr.length - 1 ? (
                                <Button variant="primary"  onClick={this.handleNext}>
                                    Next
                                </Button>
                                ) : (
                                <Button variant="success" onClick={this.handleSubmit}>
                                    Submit
                                     {
                                        this.state.savingAswersLoading == "show" ?
                                        (<Image src={loader} alt="loader" className='loader_cls ms-2 float-end'></Image>)
                                        :
                                        ("")
                                    }
                                </Button>
                                )}
                               
                            </div>
                            </Form>
                        </Card>
                        {
                            this.state.savingAnswersResponse != "" ?
                            (
                                <Row>
                                    <Col>
                                        <h6 className="text-center fw-bold mt-3">{this.state.savingAnswersResponse}</h6>
                                    </Col>
                                </Row>
                            )
                            :
                            ("")
                        }
                        </Col>
                    </Row>
                    )}

       

      </Container>
           
    </section>

    );
  }
}

export default withRouter(HouseWiseVerification);
